import React from 'react';
import classNames from 'classnames';

import { Node } from '@uncinc/react-drupal-core';

const DossiersContent = ({ entities }) => {
  return (
    <div className="DossiersContent">
      <div className="row">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const classes = classNames('DossiersContent__row col-12 col-md-6 col-lg-4');

          return (
            <div key={`${uuid}:${langcode}`} className={classes}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DossiersContent;
